<app-modal-popup
  [maxHeight]="true"
  [title]="title()"
  [message]="message()"
  icon=""
  size="med"
  [isOpen]="isOpen()"
  cancelLabel="Cancel"
  [confirmLabel]="isSwitching() ? 'Switching...' : 'Confirm'"
  [confirmDisabled]="isSwitching()"
  (confirm)="onConfirm()"
  (cancel)="onDismiss()"
  (close)="onDismiss()"
>
  <div class="switch-preview">
    <!-- Leaving -->
    <ng-container
      [ngTemplateOutlet]="card"
      [ngTemplateOutletContext]="{ $implicit: fromView(), target: false }"
    ></ng-container>

    <div class="switch-arrow" aria-hidden="true">
      <i class="fa-solid fa-angles-right"></i>
    </div>

    <!-- Entering -->
    <ng-container
      [ngTemplateOutlet]="card"
      [ngTemplateOutletContext]="{ $implicit: toView(), target: true }"
    ></ng-container>
  </div>
</app-modal-popup>

<ng-template #card let-view let-target="target">
  <div class="switch-card" [class.target]="target">
    <div class="card-logo" [class.round]="roundImage()">
      @if (view?.imageUrl) {
        <img [src]="view.imageUrl" [alt]="view.name" />
      } @else {
        <span class="logo-fallback">{{ initialOf(view) }}</span>
      }
    </div>
    <span class="card-name">{{ view?.name }}</span>
    @if (view?.subtitle) {
      <span class="card-location">{{ view.subtitle }}</span>
    }
  </div>
</ng-template>
